import Vue from 'vue'

Vue.component('custom-table', require('@/components/custom/table/Component').default)
